import { SelectProps } from 'formik-antd';
import { FC } from 'react';
import SelectStyled from './styles';

const { Option } = SelectStyled;

type Props = SelectProps & {
  data: { value: string | number; label: string; building_code?: string }[];
};

const SelectField: FC<Props> = ({ data = [], ...props }) => {
  return (
    <SelectStyled {...props} bordered={false} suffixIcon={<i className="triangle-down " />}>
      {data.length > 0 &&
        data.map((item) => (
          <Option
            key={item.value ? item.value.toString() : item.value}
            value={item.value ? item.value.toString() : item.value}
          >
            {item.building_code} {item.label}
          </Option>
        ))}
    </SelectStyled>
  );
};

export default SelectField;
